import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  template: `
    <nav aria-label="Progress">
      <ol role="list" class="flex items-center">
        @for (step of steps(); track $index) {
          <li class="relative flex-1 flex justify-center">
            <!-- Lines (rendered first to be in the background) -->
            @if (!$first) {
                <!-- Left half of the line -->
                <div class="absolute left-0 top-4 h-0.5 w-1/2" 
                     [class.bg-[var(--superyes-green)]]="currentStep() > $index" 
                     [class.bg-gray-200]="currentStep() <= $index"></div>
            }
            @if (!$last) {
                <!-- Right half of the line -->
                <div class="absolute right-0 top-4 h-0.5 w-1/2"
                     [class.bg-[var(--superyes-green)]]="currentStep() > $index + 1"
                     [class.bg-gray-200]="currentStep() <= $index + 1"></div>
            }

            <!-- Dot (rendered last, with z-index, to be on top) -->
            @if (currentStep() > $index + 1) {
              <!-- Completed Step -->
              <div class="relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-[var(--superyes-green)]">
                <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.052-.143z" clip-rule="evenodd" />
                </svg>
              </div>
            } @else if (currentStep() === $index + 1) {
              <!-- Current Step -->
              <div class="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-[var(--superyes-green)] bg-white" aria-current="step">
                <span class="h-2.5 w-2.5 rounded-full bg-[var(--superyes-green)]" aria-hidden="true"></span>
              </div>
            } @else {
              <!-- Upcoming Step -->
              <div class="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white">
                <span class="h-2.5 w-2.5 rounded-full bg-transparent" aria-hidden="true"></span>
              </div>
            }
          </li>
        }
      </ol>
    </nav>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent {
  steps = input.required<string[]>();
  currentStep = input.required<number>();
}
